/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="15.96"
        height="18.4"
        viewBox="0 0 15.96 18.4"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m15.96 18.4-.55-.79a11.52 11.52 0 0 0-7.43-4.36c-3.66-.52-5.67.82-6.76 2.23a17.09 17.09 0 0 1 4.46-9.11 5.22 5.22 0 0 1 1.24 4.2v.14l1 .17v-.15a6.3 6.3 0 0 0-1.18-4.71 3.84 3.84 0 0 1 3.82 1.94l.07.13.89-.45-.06-.13a4.73 4.73 0 0 0-4.34-2.49 5.47 5.47 0 0 1 4.24-.93h.15l.23-1h-.14a6.57 6.57 0 0 0-4.55.76 5.65 5.65 0 0 0-.1-3.74l-.06-.14-.92.39.06.14a4.94 4.94 0 0 1 0 3.37 3.81 3.81 0 0 0-3.26-2.63h-.15l-.17 1h.15a2.87 2.87 0 0 1 2.63 2.55A5.92 5.92 0 0 0 .6 4.51l-.14.05.38.93.14-.06a5 5 0 0 1 3.9.33l-.07.07-.07.08A17.89 17.89 0 0 0 .04 18.2v.15h1l14 .06Zm-12.19-1H1.28c.5-1.29 2-3.75 6.55-3.1a10.58 10.58 0 0 1 6.08 3.16Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'PalmTreeIslandIcon';

export default Icon;
